import {Injectable} from "@angular/core";
import {ILotteryRewardGroupsItem, IRewardsArrayItem} from "../definitions";
import {ISector} from "./factory-service-impl/ISector";
import {WatchService} from "./watch.service";
import {getNextId} from "../utils";
import {CONDITION_TYPES} from "../enums/e-conditions";
import {StageService} from "./conditionService";
import {JP} from "../helpers/jp";
import {RESTRICTION_TYPES} from "../enums/e-restrictions";
import {GameObjectUtils} from "./factory-service-impl/gameObject.utils";
import {IRestriction, RestrictionUtils} from "./factory-service-impl/restriction.utils";
import {ConditionsUtils} from "./factory-service-impl/conditions.utils";
import {IQuestStage} from "../interfaces/quest.definition";
import {IAchievementStage} from "../interfaces/achievement.definition";
import {ICondition} from "../interfaces/condition.definition";
import {IConditionWeights} from "../interfaces/weight-attributes.definition";
import {IScene, ISlide, ITalk, StoryUtils} from "./factory-service-impl/story.utils";
import {IDocument} from "../interfaces/document.definition";
import {SLIDES_TRANSITION_TYPES} from "../enums/e-scene-types";
import {IParticipant, OnmapDialogUtils} from "./factory-service-impl/onmap-dialog.utils";


@Injectable()
export class FactoryService {
  public gameObjectUtils: GameObjectUtils;
  public restrictionUtils: RestrictionUtils;
  public conditionsUtils: ConditionsUtils;
  public sceneUtils:StoryUtils;
  public onmapUtils:OnmapDialogUtils;


  constructor(private watchService: WatchService,
              private stageService: StageService /*todo: rename to conditionService*/) {
    this.gameObjectUtils = new GameObjectUtils(this.watchService);
    this.restrictionUtils = new RestrictionUtils(this.watchService);
    this.conditionsUtils = new ConditionsUtils(this.watchService, this.stageService);
    this.sceneUtils = new StoryUtils(this.watchService);
    this.onmapUtils = new OnmapDialogUtils(this.watchService);
  }


  pushNewBlueprint(weights: IConditionWeights): void {
    weights.push({conditionTypeId: CONDITION_TYPES.ESellStuff, stages:[true, true, true]});
    this.notify();
  }


  pushNewConditionTo(document: any, pointer: string) {
    const condition:ICondition = <ICondition> { type: CONDITION_TYPES.ESellStuff };
    this.conditionsUtils.initializeParams(condition);

    this.pushUsingPointer(document, pointer, condition);
  }


  addAchievementStage(document: any, pointer: string) {
    const newItem: IAchievementStage = <IAchievementStage>{
      conditionValue: 0,
      rewards: [],
      gpsKey:""/*,
      locales: <any>[{ key: "description", value: [""]}]*/
    };
    this.pushUsingPointer(document, pointer, newItem);
  }


  addRestrictionTo(document: any, pointer: string) {
    const restriction: IRestriction = this.restrictionUtils.createRestriction(RESTRICTION_TYPES.HAS_ITEM);
    this.pushUsingPointer(document, pointer, restriction);
  }

  addSceneTo(document: any, pointer: string) {
    const scene:IScene = this.sceneUtils.createScene(0);
    this.pushUsingPointer(document, pointer, scene);
  }

  addTalkTo(scene:IScene, pointer:string){
    const talk:ITalk = this.sceneUtils.createTalk();
    this.pushUsingPointer(scene,pointer, talk);
  }

  addRewardTo(document: any, pointer: any) {
    const newItem = {key: 0, value: 0};
    this.pushUsingPointer(document, pointer, newItem);
  }

  addRewardIconTo(document: any, pointer: any) {
    const newItem = {key: 0, value: ""};
    this.pushUsingPointer(document, pointer, newItem);
  }


  addDayOptionToDailyBonuses(options: any[]) {
    options.push({reward: []});
    this.watchService.notify();
  }


  addQuestStageTo(document: any,
                  pointer: string) {
    let stage: IQuestStage = <IQuestStage>{
      conditionValue: 0,
      canBeAsked: false,
      skipCost: 0,
      condition: {
        type: CONDITION_TYPES.ESellStuff
      }/*,
      locales: <any>[{ key: "name", value: [""]}]*/
    };

    this.stageService.initializeConditionParams(stage.condition);
    this.pushUsingPointer(document, pointer, stage);
  }


  addSectorToMap(map: IDocument, sector: any) {
    sector.cost = [];
    sector.restrictions = [];
    sector.objects = [];
    sector.roads = [];
    sector.name = Date.now();
    this.addTo(sector, map["sectorsConfig"], "sectors");
  }


  addLotteryRewardGroupIntoLevel(document: IDocument): void {
    const newRewardGroup: ILotteryRewardGroupsItem = <ILotteryRewardGroupsItem>{
      worth: 0,
      isFat: false,
      rewardsArray: []
    };
    this.addTo(newRewardGroup, document, "lotteryRewardGroups");
  }


  addRewardItemIntoLevelLotteryGroup(document: ILotteryRewardGroupsItem): void {
    const newItem: IRewardsArrayItem = <IRewardsArrayItem>{
      reward: []
    };
    this.addTo(newItem, document, "rewardsArray");
  }


  addCategoriesToSetOfGarbageGenerator(setItem: any) {
    const newCategories: any = [];
    this.addTo(newCategories, setItem, "categories");
  }


  addSetToGarbageGenerator(garbageGenerator: any): void {
    const prop: string = "sets";
    const newSet: any = {
      id: getNextId(garbageGenerator[prop]),
      name: "new set",
      minLvl: 1,
      counts: [],
      categories: []
    };
    this.addTo(newSet, garbageGenerator, prop);
  }

  addSlideTo(document:any, pointer:string)
  {
    const slide:ISlide={"url":"","transitionType":SLIDES_TRANSITION_TYPES.NONE};
    this.pushUsingPointer(document, pointer, slide);
  }

  addRewardSlotTo(document:any)
  {
    let newSlot = {"rewards":[], "icon":""};
    this.addTo(newSlot, document, "rewardSlots");
  }

  private addTo(object: any, document: any, prop: string): void {
    const container: any[] = document[prop];
    container.push(object);
    this.notify();
  }


  private pushUsingPointer(document: any,
                           pointer: string,
                           newItem: any) {
    JP.set(document, `${pointer}/-`, newItem);
    this.notify();
  }


  private notify() {
    this.watchService.notify();
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/factory.service.ts